module.exports = __webpack_public_path__ + "img/back1.397dff4d.png";